// extracted by mini-css-extract-plugin
export default {"container":"ta4ACB","stickyContainer":"bkfwOm"};